import React, { useRef, useState } from "react";
import { motion } from "framer-motion";

import ProjectItem from "../projects/ProjectItem";
import { projects } from "../../data/projectsData";

const Portfolio = () => {
    const [activeProject, setActiveProject] = useState(projects[0]);
    const [hoveredProject, setHoveredProject] = useState(null);
    const sectionRef = useRef(null);
    const projectsRef = useRef(null);

    // Handlers simplifiés
    const handleHover = (project) => setHoveredProject(project);
    const handleSetActive = (project) => setActiveProject(project);

    return (
        <section
            id="portfolio"
            className="pb-20 pt-5 md:pt-40 min-h-screen relative overflow-hidden"
            ref={sectionRef}
        >
            <div className="container mx-auto relative z-10 px-4">
                <div className="flex mx-auto justify-center items-center">
                    <div className="mb-16 max-w-2xl text-center">
                        <div className="mb-6">
                            {/* <motion.span
                                className="bg-black/80 text-white text-xs md:text-sm px-6 py-2.5 uppercase tracking-wider font-medium shadow-lg rounded-md"
                                initial={{ opacity: 0, y: -20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ delay: 0.1 }}
                            >
                                RÉALISATIONS
                            </motion.span> */}
                        </div>
                        <div>
                            <motion.h2
                                className="text-4xl md:text-5xl font-bold text-center title"
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                transition={{ delay: 0.2 }}
                            >
                                Nos dernières{" "}
                                <span className="text-gradient">
                                    réalisations
                                </span>
                            </motion.h2>
                        </div>
                    </div>
                </div>

                <div
                    className="flex flex-col md:grid md:grid-cols-2 lg:grid-cols-3 gap-6 w-full max-w-[1400px] mx-auto"
                    ref={projectsRef}
                >
                    {projects.map((project, index) => (
                        <ProjectItem
                            key={project.id}
                            project={project}
                            isActive={activeProject.id === project.id}
                            onClick={handleSetActive}
                            onHover={handleHover}
                            index={index}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default React.memo(Portfolio);
